import React from 'react';
import Helmet from 'react-helmet';
import useSiteMetadata from '@blocks-helpers/useSiteMetadata';
import { helmetJsonLdProp } from 'react-schemaorg';

const itemType = 'https://schema.org/WebPage';
const baseSiteUrl = 'https://targpatrol.com';

const Seo = ({
  title,
  description,
  excerpt,
  meta,
  keywords,
  author,
  thumbnail,
  siteUrl = baseSiteUrl,
  pathname,
  lang = 'en'
}) => {
  const site = useSiteMetadata();

  const social = (author && author.social) || site.social || [];
  const twitter =
    social.find((s) => s.name && s.name.toLowerCase() === 'twitter') || {};

  description = excerpt || description || site.description;

  thumbnail = thumbnail && thumbnail.hero && thumbnail.hero.src;
  const thumbnailUrl =
    thumbnail &&
    (thumbnail.startsWith('//')
      ? thumbnail
      : siteUrl && `${siteUrl}${thumbnail}`);

  /**
   * Meta Tags
   */

  const metaTags = [
    { itemprop: 'name', content: title || site.title, itemType },
    { itemprop: 'description', content: description },
    { name: 'description', content: description, itemType },

    { property: 'og:title', content: title || site.title },
    { property: 'og:description', content: description },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: site.name },
    { property: 'og:image', content: thumbnailUrl },

    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:site', content: site.name },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:creator', content: twitter.url },
  ];

  if (keywords && keywords.length > 0) {
    metaTags.push({ name: 'keywords', content: keywords.join(', ') });
  }

  if (meta) {
    metaTags.push(meta);
  }

  metaTags.push({ name: 'initial-scale', content: '1.0' });

  /**
   * Structured Data (JSON-LD)
   */
  const breadcrumbJsonLd = helmetJsonLdProp({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: site.name,
        item: siteUrl,
      },
      ...(pathname !== '/'
        ? [
            {
              '@type': 'ListItem',
              position: 2,
              name: title,
              item: `${siteUrl}${pathname}`,
            },
          ]
        : []),
    ],
  });

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.title}`}
      meta={metaTags}
      script={[breadcrumbJsonLd]}
    />
  );
};

export default Seo;
